import { QRContainer } from "./style-components";
import CircularProgress from "@/components/circular-progress/circular-progress";
import useQrBenefit from "@/hook/useQrBenefit/useQrBenefit";
import { BenefitAllocation } from '@/types/benefit-allocation/benefit-allocation';
import { Typography } from "antd";

interface QRBenefitProps {
	benefit: BenefitAllocation;
}

export const QRBenefit: React.FC<QRBenefitProps> = ({ benefit }) => {
	const { loading, error, qrCodeImage, remainingTime, message } = useQrBenefit(benefit);

	if (message) {
		return <Typography.Text>{message}</Typography.Text>;
	}

	if (loading) {
		return (
			<Typography.Text>Cargando...</Typography.Text>
		)
	}

	if (error) {
		return <Typography.Text color="error" data-testid="error-message">{error}</Typography.Text>;
	}

	return (
		<QRContainer>
			{loading ? (
				<CircularProgress
					periodicIntervalInSeconds={remainingTime}
					remainingTime={remainingTime}
				/>
			) : (
				<>
					{qrCodeImage && (
						<img
							src={qrCodeImage}
							alt="QR Code"
							style={{ border: '10px solid #fff' }}
							width={250}
							height={250}
						/>
					)}
					<CircularProgress
						periodicIntervalInSeconds={remainingTime}
						remainingTime={remainingTime}
					/>
				</>
			)}
		</QRContainer>
	);
};  